module.exports = __webpack_public_path__ + "img/camera-security.d60162ca.svg";